// export const apiBaseUrl = "http://251e-219-91-181-204.ngrok.io/api/v1/"
// export const apiBaseUrl = "http://192.168.0.151:8091/api/v1/"
export const apiBaseUrl = "https://api.skycars.in/api/v1/"
export const BaseUrl = "https://api.skycars.in/UploadedFiles/"


// export const apiBaseUrl = "https://2c5c-42-108-196-210.ngrok.io/api/v1/"